<template>
	<div id="appContainer" :class="{'home-page': homePage}">
		<!-- Sidebar view-->
		<MenuSidebar :class="{'home-page': homePage}"/>
		<GlobalAudio v-if="featureSet.globalAudioPlayer.enabled" />
		<div class="globallink" v-if="featureSet.globallink && $route.path !== globalLink">
			<router-link :to="globalLink">
				<fa-icon icon="envelope" />
			</router-link>
		</div>
		<div class="language-bar" v-if="featureSet.languageBar.standaloneBar" >
			<LanguageSelector :languages="languageList" />
		</div>
		<div class="social-icons-bar" v-if="featureSet.socialIcons.standaloneBar" >
			<SocialIcons />
		</div>
		<div class="background-container" v-if="backgroundsArray.length > 1" :style="backgroundStyle(0)" :class="{ 'alt' :fullWidthBackground }">
		</div>
		<div class="background-container" :style="backgroundStyle(1)" :class="{ 'alt' :fullWidthBackground }">
		</div>
		<div class="background-overlay">
		</div>
		<!-- Main child app container/main router view -->

		<div class="content-container"  :class="{'home-page': homePage}" @scroll.passive="handleScroll" ref="contentContainer">
			<div class="content-top-page" v-if="featureSet.content.contentTopPage && generalSettings['content_page']">
				<PageView :id="generalSettings['content_page']" :no-title="true" :no-title-update="true" />
			</div>
			<div class="site-header" v-if="featureSet.header.hasHeader">
				<router-link :to="'/'">
					<div class="hp-header">
						<transition name="hide-fast" mode="out-in">
							<div class="hp-header-logo" v-show="$router.currentRoute.name === 'Home'">
								<img :src="logoSrcS()">
							</div>
						</transition>
						<h1 v-if="featureSet.header.hasText" class="hp-header-text">{{ $store.state.cName }}</h1>
						<h2 v-if="featureSet.header.hasText" class="hp-header-subtext">Datenschutz</h2>
					</div>
				</router-link>
			</div>

			<transition name="fade-fast" mode="out-in">
					<router-view :key="$route.fullPath" :showButton="scrollToTopButtonEnabled" @alt-background="fullWidthBck"/>
			</transition>

			<div class="site-footer" v-if="featureSet.footer.hasFooter">
				<div class="footer-decoration" v-if="featureSet.footer.footerDecoration">
					<fa-icon class="footer-decoration-circle left" icon="circle"/>
					<div class="footer-decoration-divider"></div>
					<fa-icon class="footer-decoration-circle right" icon="circle"/>
				</div>
				<div class="h-divider">-&nbsp;-&nbsp;-</div>
				<div class="footer-page" v-if="featureSet.footer.footerPage && generalSettings['footer_page']">
					<PageView :id="generalSettings['footer_page']" :no-title="true" :no-title-update="true" />
				</div>
				<SocialIcons v-if="featureSet.footer.hasSocialIcons"/>
				<LanguageSelector :languages="languageList" v-if="featureSet.footer.hasLanguageBar"/>
				<div class="site-footer-links" v-if="featureSet.footer.hasMenu">
					<GenericMenu :menuArray="footerMenu"/>
					<div v-if="!featureSet.footer.separateCopyright"
					class="site-footer-copyright">Copyright {{ $store.state.cName }} {{ (new Date()).getFullYear() }}</div>
				</div>
			</div>
			<div v-if="featureSet.footer.separateCopyright"
			class="site-footer-copyright">Copyright {{ $store.state.cName }} {{ (new Date()).getFullYear() }}</div>
			<div class="site-footer-logos" v-if="!featureSet.footer.seal.footerInSidebar">
				<div class="site-footer-seal" v-if="featureSet.footer.seal.white || featureSet.footer.seal.black">
					<StampItem :type="featureSet.footer.seal.white ? 'white': 'black'"></StampItem>
				</div>
			</div>
		</div>
		<div class="gallery-full-view" v-if="featureSet.gallery.separateFullGalleryView">
			<GalleryFullView v-if="$store.state.gallery.selectedImageId !== ''"/>
		</div>
		<ScrollToTop :showButton="scrollToTopButtonEnabled" :target="'content-container'" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import GalleryFullView from '@/components/GalleryFullView.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import MenuSidebar from '@/views/MenuSidebar.vue';
import PageView from '@/views/PageView.vue';
import GenericMenu from '../components/GenericMenu.vue';
import ScrollToTop from '../components/ScrollToTop.vue';
import GlobalAudio from '../components/GlobalAudio.vue';
import SocialIcons from '../components/SocialIcons.vue';
import StampItem from '../components/StampItem.vue';

export default {
	name: 'MainPage',
	components: {
		MenuSidebar,
		LanguageSelector,
		ScrollToTop,
		GenericMenu,
		GlobalAudio,
		SocialIcons,
		GalleryFullView,
		PageView,
		StampItem,
	},
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	data() {
		// rotate backgrounds
		setInterval(() => {
			this.backgroundIndex += (this.backgroundIndex < this.backgroundsArray.length - 1 ? 1 : -this.backgroundsArray.length + 1);
		}, 9000);
		// set data
		return {
			backgroundImagesLocal: [],
			backgroundIndex: 0,
			scrollToTopButtonEnabled: false,
			fullWidthBackground: false,
			homePage: false,
		};
	},
	beforeCreate() {
		this.$root.$on('updateCoverImages', (filenames) => {
			this.backgroundIndex = 0;
			const tempBckImages = [];
			filenames.forEach(el => tempBckImages.push(`/storage/media/${el}`));
			this.backgroundImagesLocal = tempBckImages;
		});
		this.$root.$on('resetCoverImages', () => {
			if (this.backgroundImagesLocal.length > 0) {
				this.backgroundIndex = 0;
				this.backgroundImagesLocal = [];
			}
		});
		this.$root.$on('homePage', (value) => {
			this.homePage = value;
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.unsetTitle();
		next();
	},
	created() {
		if (this.featureSet.scrollToTop.scrollWholePage) {
			window.addEventListener('scroll', this.handleScroll);
		}
		this.$root.$on('onMountedScrollTo', this.scrollToPost);
	},
	computed: {
		// uses the static images as default
		backgroundsArray() {
			if (this.backgroundImagesLocal.length === 0) { return this.staticBackgrounds; }
			return this.backgroundImagesLocal;
		},
		// styling the alternating backgrounds
		backgroundStyle() {
			return (parity) => {
				// skip if not using them at all
				if (this.featureSet.backgrounds.solidColor) return '';
				// browser caching for the next image
				const nextImg = new Image();
				nextImg.src = this.backgroundsArray[this.backgroundIndex + 1 > this.backgroundsArray.length - 1 ? 0 : this.backgroundIndex + 1];
				// styling logic
				if (this.backgroundsArray && this.backgroundsArray.length > 1) {
					let nextIndex = -1;
					if (this.backgroundIndex % 2 === parity) {
						nextIndex = this.backgroundIndex - 1 < 0 ? this.backgroundsArray.length - 1 : this.backgroundIndex - 1;
					} else {
						nextIndex = this.backgroundIndex;
					}
					return {
						backgroundImage: `url("${this.backgroundsArray[nextIndex]}")`,
						opacity: (this.backgroundIndex % 2) === parity ? '0' : '1',
						'z-index': ((parity * 100) + 50).toString(),
					};
				}

				/* when there's one image only */
				return {
					backgroundImage: `url("${this.backgroundsArray[this.backgroundIndex]}")`,
					// opacity: '1',
					'z-index': '150',
					transition: 'none',
				};
			};
		},
		globalLink() {
			return `/page/${this.generalSettings.globallink}`;
		},
	},
	methods: {
		...mapActions('title', ['unsetTitle']),
		handleScroll(event) {
			if (event.target.scrollTop > 40) {
				this.scrollToTopButtonEnabled = true;
			} else if (document.documentElement.scrollTop > 40) {
				this.scrollToTopButtonEnabled = true;
			} else {
				this.scrollToTopButtonEnabled = false;
			}
		},
		fullWidthBck(bool) {
			this.fullWidthBackground = bool;
		},
		scrollToPost(id) {
			const { contentContainer } = this.$refs;
			const closestPost = document.querySelector(`#note-${id}`);
			if (contentContainer) {
				const top = closestPost.offsetTop - ((contentContainer.clientHeight / 2) - (closestPost.clientHeight / 2));
				// console.log(closestPost.offsetTop, top);
				contentContainer.scrollTo({ top, left: 0, behavior: 'smooth' });
			}
		},
	},

};
</script>

<style src="@/styles/views/MainPage/MainPage.less" lang="less" scoped></style>
